<template>
  <div class="main container" id="not-found">
    <h1>404</h1>
    <h2>Page not found</h2>
    <img src="@/assets/img/404.png" />
  </div>
  <Footer />
</template>

<style>
    #not-found { text-align: center; }
    #not-found img { height:400px; margin-top: 30px; }
</style>